import React, { useEffect } from 'react'
import styles from './index.module.scss';

import guideImage1 from '../assets/guide_img_1.png';
import guideImage2 from '../assets/guide_img_2.png';
import guideImage3 from '../assets/guide_img_3.png';

export default function Guide() {
  
  useEffect(() => {
    document.title = "救援指引";
  }, [])

  return (
    <div className={styles['rescue-guide-container']}>
      <div className={styles['main-title-field']}>
        <p>道路救援车辆</p>
        <p>拍摄指引</p>
      </div>
      <div className={styles['guide-section']}>
        <span className={styles['section-number']}>01</span>
        <p className={styles['title']}>在车辆前方45°拍摄整体车辆及周边环境</p>
        <div className={styles['guide-img-wrapper']}>
          <img src={guideImage1} alt="" />
        </div>
      </div>
      <div className={styles['guide-section']}>
        <span className={styles['section-number']}>02</span>
        <p className={styles['title']}>在车辆后方，拍摄整体车辆及周边环境</p>
        <div className={styles['guide-img-wrapper']}>
          <img src={guideImage2} alt="" />
        </div>
      </div>
      <div className={styles['guide-section']}>
        <span className={styles['section-number']}>03</span>
        <p className={styles['title']}>如涉及轮胎故障，需要拍摄轮胎近况，便于判断救援方案</p>
        <div className={styles['guide-img-wrapper']}>
          <img src={guideImage3} alt="" /> 
        </div>
      </div>
    </div>
  )
}
